import React, { useContext, useEffect } from 'react';
import { Kemu } from '../kemu/kemu';
import { UserSessionContext } from '@common/context/UserSessionContext/UserSessionContext';
import useAuthRedirect from '@common/hooks/useAuthRedirect';

/**
 * Renders different routes based on the user's authentication state.
 */
const AuthStateRouter = () => {
  const session = useContext(UserSessionContext);
  const { clearRedirectOnArrival, redirectToSignIn } = useAuthRedirect();

  useEffect(() => {
    if (session.state === 'NotLoggedIn') {
      redirectToSignIn();
      return;
    }

    if (session.state === 'LoggedIn') {
      clearRedirectOnArrival();
    }
  }, [clearRedirectOnArrival, redirectToSignIn, session.state]);

  if (session.state === 'LoggedIn') {
    return (
      <Kemu />
    );
  }

  if (session.state === 'NotLoggedIn') {
    return null;
  }

  // Processing?
  return null;
};

export default AuthStateRouter;
